export default {
  device: { src: require('@/assets/img/sleep-manual/device.webp'), width: 600, height: 830 },
  image1: { src: require('@/assets/img/sleep-manual/image1.webp'), width: 298, height: 347 },
  image10: { src: require('@/assets/img/sleep-manual/image10.webp'), width: 743, height: 1600 },
  image11: { src: require('@/assets/img/sleep-manual/image11.webp'), width: 743, height: 1600 },
  image12: { src: require('@/assets/img/sleep-manual/image12.webp'), width: 743, height: 1600 },
  image13: { src: require('@/assets/img/sleep-manual/image13.webp'), width: 1200, height: 901 },
  image14: { src: require('@/assets/img/sleep-manual/image14.webp'), width: 1200, height: 855 },
  image15: { src: require('@/assets/img/sleep-manual/image15.webp'), width: 1200, height: 900 },
  image16: { src: require('@/assets/img/sleep-manual/image16.webp'), width: 1200, height: 900 },
  image17: { src: require('@/assets/img/sleep-manual/image17.webp'), width: 1200, height: 854 },
  image18: { src: require('@/assets/img/sleep-manual/image18.webp'), width: 1200, height: 857 },
  image2: { src: require('@/assets/img/sleep-manual/image2.webp'), width: 277, height: 347 },
  image3: { src: require('@/assets/img/sleep-manual/image3.webp'), width: 272, height: 347 },
  image4: { src: require('@/assets/img/sleep-manual/image4.webp'), width: 356, height: 347 },
  image5: { src: require('@/assets/img/sleep-manual/image5.webp'), width: 1200, height: 855 },
  image6: { src: require('@/assets/img/sleep-manual/image6.webp'), width: 1200, height: 855 },
  image7: { src: require('@/assets/img/sleep-manual/image7.webp'), width: 1200, height: 856 },
  image8: { src: require('@/assets/img/sleep-manual/image8.webp'), width: 1200, height: 900 },
  image9: { src: require('@/assets/img/sleep-manual/image9.webp'), width: 743, height: 1600 }
}
